<template>
  <div class="w-100">
    <div class="accordion">
      <b-card no-body>
        <b-card-header @click="setIsOpen" header-tag="header" role="tab">
          <div class="row">
            <div class="col-6 accordion__title">
              <b-icon
                  icon="arrow-down-short"
                  variant="dark"
              >
              </b-icon>
              <strong>
                {{ $t('modal.segment.game_rule_title') }}
              </strong>
            </div>
            <div class="d-flex justify-content-end align-items-center col-6 text-right">
              <p v-if="isEdited" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_is_edited') }}</p>
              <p v-if="v.$invalid && v.$anyDirty" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_required') }}</p>
              <button @click="destroy" class="btn btn-xs btn-danger delete-translation-btn">{{ $t('btn.segment.delete_segment') }}</button>
            </div>
          </div>
        </b-card-header>
        <b-collapse :visible="isOpen" accordion="game" role="tabpanel">
          <div style="height: 520px;">
            <div class="row p-4 pt-5 d-flex justify-content-center align-items-start">
              <div class="col-4">
                <b-form-group
                    :label="$t('segment.label.set_segment_currency')"
                    label-for="currency"
                >
                  <b-form-select v-model="currency" @input="emitSelectedValue('currency')" :options="options.currency"></b-form-select>
                  <div class="">
                    <p v-if="v.currency.$dirty && v.currency.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                  </div>
                </b-form-group>
              </div>

                <div class="col-4">
                  <b-form-group
                      :label="$t('segment.label.set_segment_amount')"
                      label-for="amount"
                  >
                    <b-form-input v-model="amount" @input="emitSelectedValue('amount')" name="amount" id="amount"></b-form-input>
                    <div class="">
                      <p v-if="v.amount.$dirty && v.amount.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-4">
                  <b-form-group
                      :label="$t('segment.label.set_segment_condition')"
                      label-for="condition">
                    <b-form-select v-model="condition" @input="emitSelectedValue('condition')" :options="options.condition"></b-form-select>
                  <div class="">
                    <p v-if="v.condition.$dirty && v.condition.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                  </div>
                  </b-form-group>
                </div>
            </div>

            <div class="row pt-2 pl-4 pr-4 d-flex justify-content-start align-items-start">
              <div class="col-4">
                <b-form-group
                    :label="$t('segment.label.set_segment_time_operation')"
                    label-for="timeOperation">
                  <b-form-select v-model="timeOperation" @input="emitSelectedValue('timeOperation')" :options="options.timeOperation"></b-form-select>
                  <div class="">
                    <p v-if="v.timeOperation.$dirty && v.timeOperation.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                  </div>
                </b-form-group>
              </div>

              <div v-if="timeOperation === 'BETWEEN_DAYS'" class="col-4">
                <b-form-group
                    :label="$t('segment.label.set_segment_days_from')"
                    label-for="daysFrom"
                >
                  <b-form-input v-model="daysFrom" @input="emitSelectedValue('daysFrom')" name="daysFrom" id="daysFrom"></b-form-input>
                  <div class="">
                    <p v-if="v.daysFrom.$dirty && v.daysFrom.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                  </div>
                </b-form-group>
              </div>

              <div v-if="timeOperation === 'BETWEEN_DAYS'" class="col-4">
                <b-form-group
                    :label="$t('segment.label.set_segment_days_to')"
                    label-for="daysFrom"
                >
                  <b-form-input v-model="daysTo" @input="emitSelectedValue('daysTo')" name="daysTo" id="daysTo"></b-form-input>
                </b-form-group>
              </div>

              <div class="col-4" v-if="timeOperation === 'BETWEEN_DATES'">
                <b-form-group
                    :label="$t('segment.label.set_segment_date_from')"
                    label-for="validFrom"
                    class="w-50 w-100"
                >
                  <date-range-picker v-model="dateFrom.startDate"
                                     :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                                     :auto="false"
                                     :linked="false"
                                     @update="emitSelectedValue('dateFrom')"
                                     style="width: 100%;"
                                     :singleDatePicker="true"
                                     :show-week-numbers="false"
                                     :ranges="false"
                                     :opens="'center'">
                    <template v-slot:input="picker">
                      {{ picker.startDate | dateFormat }}
                    </template>
                  </date-range-picker>
                  <div class="">
                    <p v-if="v.dateFrom.$dirty && v.dateFrom.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                  </div>
                </b-form-group>
              </div>

              <div class="col-4" v-if="timeOperation === 'BETWEEN_DATES'">
                <b-form-group
                    :label="$t('segment.label.set_segment_date_to')"
                    label-for="dateTo"
                    class="w-50 w-100"
                >
                  <date-range-picker v-model="dateTo.startDate"
                                     :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                                     :auto="false"
                                     :linked="false"
                                     @update="emitSelectedValue('dateTo')"
                                     style="width: 100%;"
                                     :singleDatePicker="true"
                                     :show-week-numbers="false"
                                     :ranges="false"
                                     :opens="'center'">
                    <template v-slot:input="picker">
                      {{ picker.startDate | dateFormat }}
                    </template>
                  </date-range-picker>
                </b-form-group>
              </div>
            </div>
            </div>

            <div class="row pr-4 d-flex justify-content-center align-items-start">
              <div class="col-12">
                <button v-if="isEditType" :disabled="!isEdited" @click="saveEditedRule" class="float-right btn btn-xs btn-success">{{ $t('btn.segment.save_edited_rule') }}</button>
              </div>
            </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import {userSegment} from "../../../../common/constants/userSegment";
import DateRangePicker from "../../../../components/DateRangePicker/components/DateRangePicker";
import {mapState} from "vuex";

export default {
  components: {
    DateRangePicker
  },
  props: {
    type: {
      type: String
    },
    v: {
      type: Object,
      required: true
    },
    gameForm: Object,
    isEditType: {
      type: Boolean,
      default: false
    },
    ruleId: {
      type: String,
      default: null,
      required: false
    },
    methodPost: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    ...mapState({
      newSegmentParams: state => state.crmDashboardStore.newSegmentParams
    }),
    isEdited: function () {
      return this.$store.getters[`userSegment/getEditedRule`](userSegment.game);
    }
  },
  mounted() {
    this.$parent.$on('checkValidation', () => {
      this.v.$touch();
    });

    if(this.newSegmentParams && this.newSegmentParams.segments[userSegment.game]) {
      this.timeOperation = 'BETWEEN_DATES';

      this.dateFrom.startDate.startDate = this.newSegmentParams.dateRange.startDate;
      this.dateFrom.startDate.endDate = this.newSegmentParams.dateRange.startDate;
      this.dateTo.startDate.startDate = this.newSegmentParams.dateRange.endDate;
      this.dateTo.startDate.endDate = this.newSegmentParams.dateRange.endDate;

      this.condition = this.newSegmentParams.segments[userSegment.game].operator;
      this.amount = this.newSegmentParams.segments[userSegment.game].amount.toString();

      this.emitSelectedValue('amount');

      // this.$store.commit('crmDashboardStore/newSegmentParams', null);
    }

    // POTRZEBNE PRZY EDYCJI
    // if(this.gameForm.locales.length > 0) {
    //   this.locale = this.gameForm.locales;
    //   this.timeOperation = this.gameForm.timeOperation;
    //
    //   this.locale = this.options.localeRule.filter(rule => {
    //     if(this.gameForm.locale.includes(rule.locale)) {
    //       return rule;
    //     }
    //   });
    // }
  },
  data() {
    return {
      dateFrom: {
        startDate: {}
      },
      dateTo: {
        startDate: {}
      },
      isOpen: false,
      daysFrom: '',
      daysTo: '',
      amount: '',
      condition: '',
      timeOperation: '',
      currency: '',
      options: {
        timeOperation: [
          {value: 'BETWEEN_DATES', text: this.$t('segment.option.between_dates')},
          {value: 'BETWEEN_DAYS', text: this.$t('segment.option.between_days')}
        ],
        condition: [
          {value: 'GT', text: this.$t('segment.option.greater_than')},
          {value: 'GTE', text: this.$t('segment.option.greater_than_or_equal')},
          {value: 'LT', text: this.$t('segment.option.less_than')},
          {value: 'LTE', text: this.$t('segment.option.less_than_or_equal')},
        ],
        currency: [
          {value: 'FUN_COINS', text: this.$t('segment.option.fun_coins')},
          {value: 'QUIZ_COINS', text: this.$t('segment.option.quiz_coins')}
        ],
      }
    }
  },
  methods: {
    saveEditedRule() {
      this.$parent.$emit('editRule', {type: userSegment.game, ruleId: this.ruleId, methodPost: this.methodPost});
    },
    deleteSegmentRule() {
      this.$parent.$emit('deleteSegmentRule', this.ruleId);
    },
    destroy() {
      const data = {
        component: this,
        rule: userSegment.game,
        ruleId: this.ruleId
      }

      this.$parent.$emit('removeGame', data);
    },
    setIsOpen() {
      if(this.isEditType && !this.isEdited) {
        this.isOpen = !this.isOpen;
        return;
      } else if(this.isEditType && this.isEdited) {
        return;
      }

      this.isOpen = !this.isOpen;
    },
    emitSelectedValue(type) {
      if(this.isEditType) {
        const data = {
          key: userSegment.game,
          value: true
        }

        this.$store.commit('userSegment/setEditedRule', data);
      }

      this.$parent.$emit('selectedGame', {
        type: type,
        amount: this.amount,
        currency: this.currency,
        condition: this.condition,
        timeOperation: this.timeOperation,
        dateFrom: this.dateFrom.startDate,
        dateTo: this.dateTo.startDate,
        daysFrom: this.daysFrom,
        daysTo: this.daysTo,
      });
    }
  }
}
</script>